<template>
  <div v-if="promotion">
    <div class="card card-rounded card-shadow border-0 mb-3" v-if="promotion.imgUrl">
      <img :src="promotion.imgUrl" class="card-img-top">
      <div class="card-body">
        <h5>{{ promotion.title }}</h5>
        <p class="text-muted">{{ promotion.excerpt }}</p>
        <div class="d-flex justify-content-between align-items-center">
          <button @click="onClick(promotion)" class="btn btn-sm rounded-pill btn-primary text-nowrap px-3 ml-auto">{{ $t('Promotion.showMore') }}</button>
        </div>
      </div>
    </div>
    <div v-else class="card card-rounded card-shadow border-0 mb-3 card-bg-media">
      <div class="card-bg-media-wrapper">
        <div style="transform: translate(-20px, -60px)"><PeppersBackground></PeppersBackground></div>
      </div>
      <div class="card-body">
        <h5>{{ promotion.title }}</h5>
        <p class="text-muted">{{ promotion.excerpt }}</p>
        <div class="d-flex justify-content-between align-items-center">
          <button @click="onClick(promotion)" class="btn btn-sm rounded-pill btn-primary text-nowrap px-3 ml-auto">{{ $t('Promotion.showMore') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import PeppersBackground from '@shared/components/PeppersBackground'
  import store from '@shared/store'
  export default {
    name: 'Promotion',
    components: { PeppersBackground },
    props: ['promotion'],
    methods: {
      onClick(promotion) {
        store.setBuffer(promotion)
        this.$router.push({ name: 'promotion-redirect' })
      }
    }
  }
</script>
